export const SET_STATUSPEND = 'RSVP/SET_STATUSPEND'
export const SET_STATUSPENDS = 'RSVP/SET_STATUSPENDS'
